module.exports = __webpack_public_path__ + "static/img/img-fa3.8444717.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-fa3.png
// module id = p9Ym
// module chunks = 0